import { useCallback } from "react";
import { applyTextareaFormat } from "@/lib/receiptMarkup";
import { Button } from "@/components/ui/Button";

interface ReceiptTextToolbarProps {
  textareaId: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function ReceiptTextToolbar({
  textareaId,
  value,
  onChange,
  disabled = false,
}: ReceiptTextToolbarProps) {
  const applyFormat = useCallback(
    (wrapper: "**" | "*" | "__") => {
      const textarea = document.getElementById(textareaId) as HTMLTextAreaElement | null;
      const start = textarea?.selectionStart ?? value.length;
      const end = textarea?.selectionEnd ?? value.length;
      const result = applyTextareaFormat(value, start, end, wrapper);
      onChange(result.value);
      requestAnimationFrame(() => {
        if (!textarea) {
          return;
        }
        textarea.focus();
        textarea.setSelectionRange(result.selectionStart, result.selectionEnd);
      });
    },
    [onChange, textareaId, value],
  );

  return (
    <div className="flex flex-wrap items-center gap-1">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        disabled={disabled}
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => applyFormat("**")}
        aria-label="Fett"
        title="Fett (**text**)"
        className="min-w-8 font-bold"
      >
        B
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        disabled={disabled}
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => applyFormat("*")}
        aria-label="Kursiv"
        title="Kursiv (*text*)"
        className="min-w-8 italic"
      >
        I
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        disabled={disabled}
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => applyFormat("__")}
        aria-label="Unterstrichen"
        title="Unterstrichen (__text__)"
        className="min-w-8 underline"
      >
        U
      </Button>
      <span className="text-xs text-label-tertiary">
        Markierung: **fett**, *kursiv*, __unterstrichen__
      </span>
    </div>
  );
}
